import {
  React,
  Button,
  useState,
  useLocation,
  Modal,
} from "../utils/thirdpartyComponents";
import { splitTotal, formatMoney, getCurrencySymbol } from "../utils/helper";
import axios from "../config/axiosConfig";
import { SubscriptionandwashpriceApi } from "../utils/apiUrls";
import { MessageToaster } from "../utils/toastUtil";
import { ServiceType } from "../utils/enums";
import SmallLoader from "./SmallLoader";

const SelfServiceWashSelection = ({
  SubscriptionID,
  WashName,
  SubscriptionDetails,
  Price,
  NumberOfWashes,
  dailyWashLimit,
  show_single_wash,
  buyType,
  hasActiveSubscription,
  setShowUpdateConfirmation,
  onBuynowClick,
  subscription,
  cancelConfirmation,
  subscriptionType,
  TrialSubscriptionAvailable,
  scanAction,
  bayselectAction,
  insidelocationcheck,
  activesinglewashid,
  coords,
  isGeolocationAvailable,
  isGeolocationEnabled,
  WashTime,
  PriceForExtraTime,
  activeUserSubscriptionID,
  HasVacuumWash,
  NumberOfVacuumWashes,
  MaxVacuumTime,
  FamilyDiscount,
  ActiveBulkWash,
  CanExtentSingleWash
}: any) => {
  const [showSingleWashCancelConfirmation, setShowSingleWashCancelConfirmation] = useState(false);
  const [cancellingSingleWash, setCancellingSingleWash] = useState(false);
  const location = useLocation();
  const toaster = new MessageToaster();
  const bayTypeId = Number(new URLSearchParams(location.search).get("bayTypeId") ?? ServiceType.selfServe);
  const isSingleWash = Number(subscriptionType) === 1;

  const cancelSingleWashCancellation = () => {
    setShowSingleWashCancelConfirmation(false);
  };

  const cancelSinglewashConfirm = () => {
    setShowSingleWashCancelConfirmation(true);
  };

  const cancelSingleWash = async () => {
    const selectedBay = localStorage.getItem("selectedBay");
    try {
      setCancellingSingleWash(true);
      const responseSingleWash = await axios.get(
        SubscriptionandwashpriceApi.CANCEL_SINGLE_WASH +
          "?bayId=" +
          selectedBay +
          "&bayType=" +
          bayTypeId
      );

      if (responseSingleWash?.data?.error === 0) {
        setShowSingleWashCancelConfirmation(false);
        toaster.toastSuccess(responseSingleWash?.data?.message);
      //  window.location.reload();
      } else {
        setShowSingleWashCancelConfirmation(false);
        toaster.toastError(responseSingleWash?.data?.message);
      }
    } catch (error: any) {
      setShowSingleWashCancelConfirmation(false);
      toaster.toastError(error.response?.data?.message || error.message);
    } finally {
      setCancellingSingleWash(false);
    }
  };

  const handleCancelClick = () => {
    if (isSingleWash) {
      cancelSinglewashConfirm();
      return;
    }
    cancelConfirmation(activeUserSubscriptionID);
  };
  const { dollars, cents } = Price
    ? splitTotal(Price)
    : { dollars: "", cents: "" };
  const centswith2Digit = cents && cents.length < 2 ? cents + "0" : cents;
  let btnLabel = "Buy";
  if (
    subscriptionType == 2 &&
    subscription.isTrial &&
    TrialSubscriptionAvailable === true
  ) {
    btnLabel = "Start Trial";
  }

         const activewashCheck = () => {
        if(subscriptionType == 1)
        {
            if (  insidelocationcheck === true && activesinglewashid == 0 && 
                  (isGeolocationAvailable && isGeolocationEnabled && coords !== undefined && coords?.latitude && coords?.longitude))
                  {
                    return true
                  }
                  else{
                     return false
                  }
           

        }
        else  if(subscriptionType == 3){
            if (  insidelocationcheck === true && ActiveBulkWash == false && 
                  (isGeolocationAvailable && isGeolocationEnabled && coords !== undefined && coords?.latitude && coords?.longitude))
                  {
                    return true
                  }
                  else{
                     return false
                  }

        }
      
        else{
           return false 
        }

        
        

    }

  return (
    <div className="cw-card">
      <div className="cw-card-content d-flex align-items-center">
        <div className="cw-card-leftcontent">
          <h6 className="m-0 text-capitalize">{WashName}</h6>
        </div>
        <div className="cw-card-rightcontent">
          <div className="cw-card-value">
            {getCurrencySymbol()}{dollars || "0"} 
            <span className="decimal-sec">
              .{cents ? centswith2Digit : "00"}
            </span>
          </div>
          {subscriptionType == 2 ? (
            <div className="cw-card-smalltext">Per Month</div>
          ) : <div className="cw-card-smalltext cw-min-text"> {WashTime} Min</div>}
        </div>
      </div>
      {subscriptionType == 2 ? (
        <>
        <div className="wash-number mt-2">
          Minutes Available <span className="ms-1">{WashTime}</span>
        </div>
          {HasVacuumWash == 1 ?       <div className="wash-number mt-3"> <span >{NumberOfVacuumWashes} </span> Free Vacuum {NumberOfVacuumWashes === 1 ? "session" : "sessions"} available for <span >{MaxVacuumTime}</span> min per use</div>  :""}

        </>
      ) :<>   {subscriptionType ==1 && CanExtentSingleWash != 0  ?<div className="cw-amount-strip text-center">
      <span>{formatMoney(PriceForExtraTime)}</span> for Each Additional Minute
    </div>:""}
     {HasVacuumWash == 1 ?       <div className="wash-number mt-3"> <span >{NumberOfVacuumWashes} </span> Free Vacuum {NumberOfVacuumWashes === 1 ? "session" : "sessions"} available for <span >{MaxVacuumTime}</span> min per use</div>  :""}
    </>
    }
      {(isGeolocationAvailable && isGeolocationEnabled && coords !== undefined && coords?.latitude && coords?.longitude )? '' : subscriptionType == 2 || scanAction === true || bayselectAction === true || localStorage.getItem('locationPermissionGranted') === 'true'  ? '' : <div className="warn-plan d-flex align-items-center fw-semibold">Please allow Location permission for this app to check your proximity to the car wash location.</div>}
      {(isGeolocationAvailable && isGeolocationEnabled && coords !== undefined && coords?.latitude && coords?.longitude &&  insidelocationcheck === false)? (subscriptionType == 2 || scanAction === true || bayselectAction === true  ? '' : <div className="warn-plan d-flex align-items-center fw-semibold">Purchase this wash at the car wash.</div> ) : ''}

      <div className={NumberOfWashes ? "cw-card-btnwrap" : "cw-card-btnwrap"}>
        {hasActiveSubscription != SubscriptionID && activesinglewashid !=SubscriptionID? (
          <Button
            variant="primary"
            className="primary-btn"
            onClick={() =>
              onBuynowClick(
                subscription,
                buyType === 2 ? "subscriptions" : "singlewash"
              )
            }
            
             disabled={
                  subscriptionType == 2 ||
                   scanAction === true || 
                   bayselectAction === true ||  
                    activewashCheck() == true
                    ? false 
                    : true
                }
          >
            {btnLabel}
          </Button>
        ) : (
          <Button
            variant="primary"
            className="primary-btn"
            onClick={handleCancelClick}
            disabled={cancellingSingleWash}
          >
            Cancel
          </Button>
        )}
      </div>
      {(subscriptionType == 2 &&  FamilyDiscount && FamilyDiscount>0)? <div className="trial-strip"><p >Family Plan Amount {formatMoney(FamilyDiscount)} Per Month</p></div> : ''}

      <Modal
        show={showSingleWashCancelConfirmation}
        onHide={cancelSingleWashCancellation}
        centered
        className="notification-modal"
      >
        <Modal.Body className="text-center">
          <h6>
            Are you sure you want to cancel this single {bayTypeId === ServiceType.vacuumWash ? "use" : "wash"}?
          </h6>
        </Modal.Body>
        <Modal.Footer className="d-grid">
          <Button variant="light" className="m-0" onClick={cancelSingleWashCancellation}>
            No
          </Button>
          <Button variant="primary" className="primary-btn btn-main m-0" onClick={cancelSingleWash}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {cancellingSingleWash ? <SmallLoader /> : null}
    </div>
  );
};
export default SelfServiceWashSelection;
